export default "__VITE_ASSET__7q5u7zEF__"